import { useCallback } from "react";
import type { FormShallowStoreHook } from "../../store";

/**
 * Returns a callback that walks back the record of a field having been answered — it becomes
 * untouched again, so no validation message shows, and it leaves the submission set.
 *
 * Used when a field's value is invalidated by something other than the enduser, so that the wizard
 * does not go on treating it as answered.
 */
export const useForgetAnsweredFields = ({ useFormShallowStore }: { useFormShallowStore: FormShallowStoreHook }) => {
  const { touchedFields, setTouchedFields, includedFieldIds, setIncludedFieldIds } = useFormShallowStore(
    "touchedFields",
    "setTouchedFields",
    "includedFieldIds",
    "setIncludedFieldIds"
  );

  return useCallback(
    (fieldIds: ReadonlySet<string>) => {
      if (!fieldIds.size) return;

      setTouchedFields(new Set([...touchedFields].filter((id) => !fieldIds.has(id))));
      if (includedFieldIds) {
        setIncludedFieldIds(new Set([...includedFieldIds].filter((id) => !fieldIds.has(id))));
      }
    },
    [touchedFields, setTouchedFields, includedFieldIds, setIncludedFieldIds]
  );
};
